<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

</script>

<template>
    <footer class="bg-gray-900 text-white">
        <div class="container mx-auto px-4 py-12">
            <div class="footer-content flex flex-col md:flex-row justify-between gap-8">
                <div class="footer-logo">
                    <img src="/images/0.png" alt="宜宾纸业股份有限公司logo" class="h-16 mb-4">
                    <p class="text-gray-400">{{ t('footer.slogan') }}</p>
                </div>
                <div class="footer-links flex flex-col md:flex-row gap-8">
                    <div class="footer-links-column">
                        <h3 class="text-xl font-bold mb-4 text-gray-100">{{ t('footer.quickLinks') }}</h3>
                        <ul class="space-y-2">
                            <li><router-link to="/" class="text-gray-400 hover:text-white transition-colors duration-300">{{ t('nav.home') }}</router-link></li>
                            <li><router-link to="/about" class="text-gray-400 hover:text-white transition-colors duration-300">{{ t('nav.about') }}</router-link></li>
                            <li><router-link to="/products" class="text-gray-400 hover:text-white transition-colors duration-300">{{ t('nav.products') }}</router-link></li>
                            <li><router-link to="/technology" class="text-gray-400 hover:text-white transition-colors duration-300">{{ t('nav.technology') }}</router-link></li>
                            <li><router-link to="/sustainability" class="text-gray-400 hover:text-white transition-colors duration-300">{{ t('nav.sustainability') }}</router-link></li>
                        </ul>
                    </div>
                    <div class="footer-links-column">
                        <h3 class="text-xl font-bold mb-4 text-gray-100">{{ t('footer.moreInfo') }}</h3>
                        <ul class="space-y-2">
                            <li><router-link to="/sustainability" class="text-gray-400 hover:text-white transition-colors duration-300">{{ t('nav.sustainability') }}</router-link></li>
                            <!-- <li><router-link to="/news" class="text-gray-400 hover:text-white transition-colors duration-300">{{ t('footer.news') }}</router-link></li>
                            <li><router-link to="/careers" class="text-gray-400 hover:text-white transition-colors duration-300">{{ t('footer.careers') }}</router-link></li> -->
                            <li><router-link to="/contact" class="text-gray-400 hover:text-white transition-colors duration-300">{{ t('nav.contact') }}</router-link></li>
                        </ul>
                    </div>
                    <div class="footer-links-column">
                        <h3 class="text-xl font-bold mb-4 text-gray-100">{{ t('footer.contact') }}</h3>
                        <ul class="contact-info space-y-2">
                            <li class="flex items-center text-gray-400">
                                <i class="fas fa-map-marker-alt mr-2"></i>
                                {{ t('footer.address') }}
                            </li>
                            <li class="flex items-center text-gray-400">
                                <i class="fas fa-phone mr-2"></i>
                                {{ t('footer.phone') }}
                            </li>
                            <li class="flex items-center text-gray-400">
                                <i class="fas fa-envelope mr-2"></i>
                                {{ t('footer.email') }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="footer-bottom mt-8 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center">
                <p class="text-gray-400">&copy; {{ new Date().getFullYear() }} {{ t('company.name') }}. {{ t('footer.rights') }}</p>
                <div class="social-links flex gap-4 mt-4 md:mt-0">
                    <a href="#" class="text-gray-400 hover:text-white transition-colors duration-300">
                        <i class="fab fa-weixin text-xl"></i>
                    </a>
                    <a href="#" class="text-gray-400 hover:text-white transition-colors duration-300">
                        <i class="fab fa-weibo text-xl"></i>
                    </a>
                    <a href="#" class="text-gray-400 hover:text-white transition-colors duration-300">
                        <i class="fab fa-linkedin text-xl"></i>
                    </a>
                </div>
            </div>
        </div>
    </footer>
</template>

<style scoped>
</style> 